/**
 *
 * Mixin
 *
 */

import { mapState } from 'vuex';

import { ExerciseMixin } from '../Exercise';
import { NoteContainerMixin } from './NoteContainer';
import { QaContainerMixin } from './QaContainer';

export const QuestionNoteQaContainerMixin = {
  mixins: [ExerciseMixin, NoteContainerMixin, QaContainerMixin],

  computed: {
    ...mapState({
      ms_isDebug: 'isDebug',
    }),
  },
};
